// extracted by mini-css-extract-plugin
export default {"followButton":"FollowButton-module__followButton___3i9RP","followingButton":"FollowButton-module__followingButton___2nbxJ"};